<template>
  <div>
    <v-container>
      <div
        class="display-2 mb-7 mt-5 font-weight-thin"
        color="primary"
      >{{$tc('analyzeInput.title',1)}}</div>
    </v-container>
    <v-list>
      <v-list-item-subtitle class="ma-5">{{$tc('analyzeInput.group',1)}}</v-list-item-subtitle>
      <div v-for="(group,i) in groups" :key="i">
        <v-list-item @click="clickGroup(group)">
          <v-list-item-action>
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{group}}</v-list-item-title>
        </v-list-item>
        <v-divider />
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      groups: []
    };
  },
  methods: {
    clickGroup(group) {
      this.$router.push({ name: "AnalyzeInput", query: { group } });
    },
    async getGroups() {
      let res = await this.$http.get("analyzeinput/groups");
      if (res.success) this.groups = res.data;
    }
  },
  async mounted() {
    await this.getGroups();
  }
};
</script>